import Vue from "vue";
import Vuex from "vuex";
import { palFormUrl } from "./config/appConfig";
import { customFetch } from "./utils/api";
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    showCustomerService: false,
    showLeaveMessage: false,
    isMobile: document.documentElement.clientWidth < 992,
    allCategories: [],
    isOpenMenu: false,
    searchOption: {
      type: "Products",
      condition: "",
    },
  },
  getters: {
    rowType: (state) => {
      return state.isMobile ? "" : "flex";
    },
  },
  mutations: {
    showCustomerService(state) {
      state.showCustomerService = true;
    },
    hideCustomerService(state) {
      state.showCustomerService = false;
    },
    toggleLeaveMessage(state) {
      state.showLeaveMessage = !state.showLeaveMessage;
    },
    hideLeaveMessage(state) {
      state.showLeaveMessage = false;
    },
    setMobile(state, isMobile) {
      state.isMobile = isMobile;
    },
    getAllCategories(state, allCategories) {
      state.allCategories = allCategories;
    },
    setOpenMenuStatus(state, isOpenMenu) {
      state.isOpenMenu = isOpenMenu;
    },
    searchFor(state, searchParams) {
      state.searchOption = searchParams;
    },
  },
  actions: {
    getAllCategories(context, state) {
      // context.commit("getAllCategories", state);
      customFetch(
        `${palFormUrl}/international/getInternationalProductsCategoryList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: 0,
          }),
        },
        (res) => {
          context.commit("getAllCategories", res.result);
          localStorage.allCategories = JSON.stringify(res.result);
        },
        () => {}
      );
    },
  },
});
